import React, { useMemo, useState } from 'react';
import styles from './index.module.less';
import { mainLabelMap, getRouteTitleMap, getPageTitleMap } from '@/common/mainLabel';
import Image from 'next/image';
import { Button, Carousel } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const TopContent = ({ data }: { data?: any }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const bannerList = [
    { thumb: '/images/landing/top-banner1.webp', main: '/images/landing/top-banner1-.webp' },
    { thumb: '/images/landing/top-banner2.webp', main: '/images/landing/top-banner2-.webp' },
    { thumb: '/images/landing/top-banner3.webp', main: '/images/landing/top-banner3-.webp' },
    { thumb: '/images/landing/top-banner4.webp', main: '/images/landing/top-banner4-.webp' },
    { thumb: '/images/landing/top-banner5.webp', main: '/images/landing/top-banner5-.webp' }
  ];

  const h1Title = useMemo(() => {
    return getRouteTitleMap(data?.pathId, data?.label, data?.gender);
  }, [data]);
  const getTitle = useMemo(() => {
    return getPageTitleMap(data?.pathId, data?.label, data?.gender);
  }, [data]);

  return (
    <div className={styles.topContentRoot}>
      <div className={styles.content}>
        <h1 style={{ display: 'none', width: 0, height: 0 }}>{h1Title}</h1>

        <div className={styles.title}>
          {mainLabelMap.get(data?.pathId) == 'Hair Types' && (
            <>
              <span style={{ color: '#FFFFFF' }}>Best </span>
              <span>Hairstyles</span>
              <span style={{ color: '#FFFFFF' }}>For {getTitle}</span>
            </>
          )}
          {mainLabelMap.get(data?.pathId) == 'Colors' && (
            <>
              <span style={{ color: '#FFFFFF' }}>{getTitle}</span>
              <span style={{ color: '#FFFFFF' }}>Virtual </span>
              <span>Hair Color</span>
              <span style={{ color: '#FFFFFF' }}>Try-On</span>
            </>
          )}

          {mainLabelMap.get(data?.pathId) == 'Trending' && (
            <>
              <span style={{ color: '#FFFFFF' }}>{getTitle}</span>
              <span style={{ color: '#B57CCE' }}>Trending</span>
              <span style={{ color: '#FFFFFF' }}>Hairstyles in 2025</span>
            </>
          )}
          {mainLabelMap.get(data?.pathId) == 'Face Shapes' && (
            <>
              <span style={{ color: '#FFFFFF' }}>The Best Hairstyles for</span>
              <span style={{ color: '#53BD70' }}>{getTitle}</span>
            </>
          )}
        </div>
        <p className={styles.desc}>
          Ready for a hair makeover? Instantly try on hundreds of hairstyles with our{' '}
          <span style={{ color: '#68F3F6' }}>AI hairstyle simulator</span>—no salon visit needed. Find your perfect look
          in seconds!
        </p>
        <Button
          className={styles.tryBtn}
          icon={<ArrowRightOutlined style={{ color: '#FFF' }} />}
          iconPosition="end"
          onClick={() => {
            const anchor = document.getElementById('main-content-anchor');
            if (anchor) {
              anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }}
        >
          {'Try On Now!'}
        </Button>
        <div className={styles.trustedRow}>
          <Image
            src={'/images/hairstyle/index-many-up.webp'}
            className={styles.trustedImg}
            alt=""
            width={61}
            height={25}
          />
          <div className={styles.trustedContainer}>
            <span>{'Trusted by'}</span>
            <span style={{ color: '#9873ff' }}> {'1,539'} </span>
            <span>{'satisfied customers'}</span>
          </div>
        </div>
      </div>
      <div className={styles.bannerContainer}>
        <div className={styles.mainImage}>
          <Image
            src={bannerList[currentSlide].main}
            alt="main image"
            width={580}
            height={350}
            style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
          />
        </div>
        <div className={styles.carouselWrapper}>
          <Carousel
            dots={false}
            slidesToShow={5}
            infinite={true}
            autoplay={true}
            autoplaySpeed={2000}
            beforeChange={(_, next) => setCurrentSlide(next)}
            className={styles.carousel}
            ref={(carousel) => {
              if (carousel) {
                (window as any).carousel = carousel;
              }
            }}
          >
            {bannerList.map((item, index) => (
              <div
                key={index}
                className={styles.carouselItem}
                onClick={() => {
                  const carousel = (window as any).carousel;
                  if (carousel) {
                    carousel.goTo(index);
                  }
                }}
              >
                <Image
                  src={item.thumb}
                  alt={`banner ${index + 1}`}
                  width={80}
                  height={96}
                  className={currentSlide === index ? styles.active : ''}
                />
              </div>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default TopContent;
